<template>
    <div class="upload-multiple-image">
        <div class="image-preview" v-if="selectedImage" :style="{backgroundImage: 'url(\'' + selectedImage + '\')'}">
        </div>
        <ul class="image-list" style="margin-bottom: 0;position:relative;" @mouseover="showDrag = true" @mouseleave="showDrag = false">
            <div class="tooltip top" role="tooltip" style="opacity:1;left:50%;margin-left:-61px;top:-33px;" v-if="showDrag">
                <div class="tooltip-arrow"></div>
                <div class="tooltip-inner">
                    Drag to order image
                </div>
            </div>
            <draggable :list="images" class="dragArea" :move="checkMove">
                <li class="preview-img" v-for="(image, index) in images" :key="index" @click="selectedImage = image" :style="{backgroundImage: 'url(\'' + image + '\')'}">
                    
                    <div class="overlay">
                        <span class="glyphicon glyphicon-remove" @click="removeImage(index)"></span>
                    </div>
                </li>
             </draggable>
        </ul>
        <div class="addButton" v-if="images.length < limit">
            <p class="text-center" >
                <a href="javascript:void(0);" class="btn btn-primary btn-xs" onclick="document.getElementById('photoUploadInput').click()"><span class="glyphicon glyphicon-camera middle"></span>    Select file to upload</a><br>
                <span class="small">
                    Upload File Size : 2MB 
                </span>
            </p>
        </div>
        <div class="has-error" v-if="isAlert">
            <p class="text-error">
                Please try to upload file again
            </p>
        </div>
        <div class="has-error">
            <p class="text-error" v-show="errors.has('photoUpload')">{{ errors.first('photoUpload') }}</p>
        </div>
        <input type="file" class="form-control-file pt-2" name="photoUpload" id="photoUploadInput" data-vv-as="File" v-validate="'image|size:2000'" @change="onFileChange($event)" style="overflow: hidden;position: fixed;width: 1px;height: 1px;z-index: -1;opacity: 0;">
    </div>
</template>

<script>
import api from '@/api'
import draggable from 'vuedraggable'

export default{
	props: ['value','max'],
	data: function(){
		return {
            limit: this.max,
            images : this.value,
            isAlert : false,
            selectedImage : null ,
            showDrag: false
		}
    },
    components: {
        draggable
    },
	mounted: function(){
        let vm = this;
        if (vm.images.length >= 1) {
            vm.selectedImage = vm.images[0]
        }
	},
	methods:{
        fileResize: function(file,callback){
            let vm = this
            var reader = new FileReader();
            reader.onloadend = function() {
        
                var tempImg = new Image();
                tempImg.src = reader.result;
                tempImg.onload = function() {
            
                    var MAX_WIDTH = 1000;
                    var MAX_HEIGHT = 1000;
                    var tempW = tempImg.width;
                    var tempH = tempImg.height;
                    if (tempW > tempH) {
                        if (tempW > MAX_WIDTH) {
                        tempH *= MAX_WIDTH / tempW;
                        tempW = MAX_WIDTH;
                        }
                    } else {
                        if (tempH > MAX_HEIGHT) {
                        tempW *= MAX_HEIGHT / tempH;
                        tempH = MAX_HEIGHT;
                        }
                    }
            
                    var canvas = document.createElement('canvas');
                    canvas.width = tempW;
                    canvas.height = tempH;
                    var ctx = canvas.getContext("2d");
                    ctx.drawImage(this, 0, 0, tempW, tempH);
                    var dataURL = canvas.toDataURL("image/jpeg");
                    var data = 'image=' + dataURL;
                    var obj = vm.dataURItoBlob(data);
                    obj.name = file.name;
                    callback(obj)
                }
            
            }
            reader.readAsDataURL(file);
        },
        dataURItoBlob: function(dataURI){
            // convert base64/URLEncoded data component to raw binary data held in a string
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0)
                byteString = atob(dataURI.split(',')[1]);
            else
                byteString = unescape(dataURI.split(',')[1]);

            // separate out the mime component
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

            // write the bytes of the string to a typed array
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            return new Blob([ia], {type:mimeString});
        },
        checkMove: function(event){
            let vm =this 
            vm.$emit('input',vm.images );
        },
		onFileChange: function(event){
            let vm = this
			let files = event.target.files || event.dataTransfer.files;
            if (!files.length)
                return
            vm.fileResize(files[0],function(obj){
                vm.createImage(obj)
            })
            event.target.value = ""
		},
		createImage(file) {
	        let reader = new FileReader()
	        let vm = this
	        vm.upload(file)
	    },
	    upload(file){
	    	let data = {
	    		name: file.name,
	    		type: file.type,
	    		file: file
	    	}
	    	let vm = this
	    	vm.$store.dispatch('loading')
	        api.getSignedRequest(data,function(error,url){
	        	if (error) {
                    console.error(error)
                    vm.$store.dispatch('loading')
	        		return
                }
                
                url = encodeURI(url)
                vm.images.push(url)
                if (vm.images.length >= 1 && vm.selectedImage == null) {
                    vm.selectedImage = vm.images[0]
                }
	        	vm.$emit('input', vm.images);
	        	vm.$store.dispatch('loading')
	        	// vm.$emit('onUploaded',url)
	        });
        },
        removeImage: function(index){
            let vm = this
            if (vm.images[index] === vm.selectedImage) {
                vm.selectedImage = null
            }
            vm.images.splice(index,1)

            vm.$emit('input', vm.images);
        }
	},
	watch: {
		'value': function(newVal, oldVal){
            let vm = this
            if (newVal != oldVal) {
                vm.images = []
                $.each(newVal,function(index, val){
                    vm.images.push(val)
                })
                
                if (vm.images.length >= 1) {
                    vm.selectedImage = vm.images[0]
                }
            }
		}
	}
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/elements/UploadMultipleFile.vue